











































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
/* api */
import MypageApi from '@/app/model/api/mypageApi'
/* module */
import Local from '@/app/module/local'
import { userType } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    CommonHeader
  }
})
export default class Master extends Vue {
  private showMenuInfoModal: boolean = false
  private isAllViewer: boolean = false
  private externalLinkTitle: string = ''

  created () {
    if (parseInt(Local.getUserType()!) === userType.USER_TYPE_ALL_VIEWER) {
      this.isAllViewer = true
    }
    this.externalLinkTitle = CommonClass.getServiceFunctionData().external_link.external_link_name
  }
}
